import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Container as BlockContainer, Features } from '../components/Blocks'
import { Hero, BecomeMember } from '../components/Sections'
import { Container, Row, Col } from 'reactstrap'
import { Link } from 'gatsby'

const IndexPage = () => (
  <Layout>
    <SEO title="Parts" keywords={[`gatsby`, `application`, `react`]} />
     <Hero src='koopsiklo/parts-banner.jpg'  fullMobile height={300} x={10} y={100} />
    <BlockContainer padding={5}>
      <Container height={500}>
        <Row>
          <Col md="12">
              <div className="text-justify">
                <h5 style={{fontWeight: 400}} align="center">At KoopSiklo, we <b>only sell 100% genuine parts and accessories</b> to ensure your motorcycle’s </h5>
                <h5 style={{fontWeight: 400}} align="center">performance, safety, and durability. Ride with confidence<b>—no imitations, no compromises.</b></h5>
              </div>
          </Col>
        </Row>
      </Container>
    </BlockContainer>
  </Layout>
)

export default IndexPage
